import Admin from "../Admin";
import React from "react";
import CardAdminOrderStatusReasonGeneral from "../../../Component/Card/Admin/OrderStatusReason/CardAdminOrderStatusReasonGeneral";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUISaveButton from "@mui/icons-material/Save";
import MUILoadingButton from "@mui/lab/LoadingButton";
import Menu from "../../../Component/Menu";
import DialogConfirm from "../../../Component/Dialog/DialogConfirm";
import MUIMenuItem from "@mui/material/MenuItem";
import MUIListItemIcon from "@mui/material/ListItemIcon";
import ReasonService from "../../../Seating/Settings/reasonService";
import Validator from "../../../Utility/Validator";
import OrderStatusReason from "../../../Utility/Crud/OrderStatusReason";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";

export default class AdminOrderStatusReasonCreateEdit extends Admin {
  constructor(props) {
    super(props);

    this.state.orderStatusReason = null;
    this.state.isProcessing = false;
    this.state.isUpdate = !!props.match.params.id;
    this.state.confirmDialogOpen = false;
    this.state.validationIssues = {};
  }

  /**
   * Set the orderStatusReason in the state.
   */
  afterComponentDidMount() {
    const orderStatusReasonId = this.props.match.params.id
      ? +this.props.match.params.id
      : null;
    if (orderStatusReasonId !== null) {
      this.setState({
        orderStatusReason:
          this.context.orderStatusReasonsIndexed[orderStatusReasonId],
      });
    }
  }

  /**
   * Creates the orderStatusReason with the current properties in state.orderStatusReason.
   */
  async createOrderStatusReason() {
    this.setState({
      isProcessing: true,
    });

    return ReasonService.createReason(this.state.orderStatusReason)
      .then((orderStatusReason) => {
        this.context.updateIndexed(
          "orderStatusReasonsIndexed",
          orderStatusReason,
        );
        this.props.history.goBack();
        NotistackEnqueueSnackbar("Order Status Reason created successfully!", {
          variant: "success",
        });
      })
      .catch((err) => {
        // JZ. We need to test and make sure that Sentry still captures
        // errors when we catch them in the application.
        console.log(err);
        NotistackEnqueueSnackbar(
          "Oh no! There was an error creating a new Order Status Reason.",
          { variant: "error" },
        );
        this.setState({
          isProcessing: false,
        });
      });
  }

  /**
   * Updates the orderStatusReason with the current properties in state.orderStatusReason.
   */
  async updateOrderStatusReason() {
    this.setState({
      isProcessing: true,
    });

    return ReasonService.updateReason(this.state.orderStatusReason)
      .then((orderStatusReason) => {
        this.context.updateIndexed(
          "orderStatusReasonsIndexed",
          orderStatusReason,
        );
        this.props.history.goBack();
        NotistackEnqueueSnackbar("Order Status Reason updated successfully!", {
          variant: "success",
        });
      })
      .catch((err) => {
        console.log(err);
        NotistackEnqueueSnackbar(
          "Oh no! There was an error updating the Order Status Reason.",
          { variant: "error" },
        );
        this.setState({
          isProcessing: false,
        });
      });
  }

  async deleteOrderStatusReason() {
    this.setState({
      isProcessing: true,
    });

    return ReasonService.deleteReason(this.state.orderStatusReason.id)
      .then(() => {
        this.context.deleteIndexed(
          "orderStatusReasonsIndexed",
          this.state.orderStatusReason.id,
        );
        this.props.history.goBack();
        NotistackEnqueueSnackbar("Order Status Reason deleted successfully!", {
          variant: "success",
        });
      })
      .catch((err) => {
        console.log(err);
        NotistackEnqueueSnackbar(
          "Oh no! There was an error deleting the Order Status Reason.",
          { variant: "error" },
        );
        this.setState({
          confirmDialogOpen: false,
        });
      });
  }

  /**
   * Render the content.
   */
  renderContent() {
    const handleChange = (orderStatusReason) => {
      this.setState({
        orderStatusReason: {
          ...this.state.orderStatusReason,
          ...orderStatusReason,
        },
      });
    };

    return (
      <>
        <CardAdminOrderStatusReasonGeneral
          orderStatusReason={this.state.orderStatusReason}
          onChange={handleChange.bind(this)}
          validationIssues={this.state.validationIssues}
        />
        <DialogConfirm
          open={this.state.confirmDialogOpen}
          onClose={() => this.setState({ confirmDialogOpen: false })}
          onConfirm={() => this.deleteOrderStatusReason()}
          text="Are you sure you want to delete this Order Status Reason? This cannot be undone."
          header="Delete Order Status Reason"
          loading={this.state.isProcessing}
        />
      </>
    );
  }

  /**
   * Renders the header.
   */
  renderHeader() {
    let title;
    let subtitle;
    const buttonText = this.state.isUpdate ? "Save" : "Create";

    if (!this.state.isUpdate) {
      title = "Create Order Status Reason";
      subtitle = null;
    } else {
      title = "Edit Order Status Reason";
      subtitle =
        this.state.orderStatusReason &&
        OrderStatusReason.getDisplayName(this.state.orderStatusReason) +
          " • " +
          this.state.orderStatusReason.id;
    }

    const handleClickBack = () => {
      this.props.history.goBack();
    };

    const handleClickSave = () => {
      const validationIssues = Validator.validate(
        this.state.orderStatusReason,
        {
          description: {
            required: true,
          },
          orderStatus: {
            required: true,
          },
        },
      );

      this.setState({
        validationIssues: validationIssues,
      });

      if (Object.keys(validationIssues).length === 0) {
        if (this.state.isUpdate) {
          this.updateOrderStatusReason();
        } else {
          this.createOrderStatusReason();
        }
      } else {
        NotistackEnqueueSnackbar("Please correct the displayed issues.", {
          variant: "error",
        });
      }
    };

    const handleDelete = () => {
      this.setState({
        confirmDialogOpen: true,
      });
    };

    const buttons = [
      <MUIButton onClick={handleClickBack}>Back</MUIButton>,
      <MUILoadingButton
        loading={this.state.isProcessing}
        loadingPosition="start"
        onClick={handleClickSave}
        variant="contained"
        startIcon={<MUISaveButton />}
      >
        {buttonText}
      </MUILoadingButton>,
    ];

    if (this.state.isUpdate) {
      const menuItems = [
        <MUIMenuItem onClick={handleDelete}>
          <MUIListItemIcon>
            <MUIDeleteIcon fontSize="small" />
          </MUIListItemIcon>
          Delete
        </MUIMenuItem>,
      ];
      buttons.push(<Menu menuItems={menuItems} />);
    }

    return <PageHeader title={title} subtitle={subtitle} buttons={buttons} />;
  }
}
